// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__dZzR5","addWidgetButton":"Header_addWidgetButton__2Gqpk","dashboardTabs":"Header_dashboardTabs__3xNZv","active":"Header_active__2nTVQ"};